import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-details-row',
    templateUrl: './details-row.component.html',
    styleUrls: ['./details-row.component.scss'],
    standalone: false
})
export class DetailsRowComponent {
	@Input() label: string;
	@Input() value: string;
	@Input() tooltip = "";
}
